export const savingsOverviewNn = {
    savingsOverview: {
        savingsDistributionSummary: {
            ariaLabel: 'Oversikt over sparing',
            loadingLabel: 'Lastar oversikt over sparing',
            totalLabel: 'Total sparing',
            savingsLabel: 'Sparekonto',
            fundsLabel: 'Fond',
            sharesLabel: 'Aksjar',
            errorHeading: 'Kunne ikkje hente oversikt over sparing',
            errorText: 'Vi klarte ikkje å hente sparebeløpet ditt. Prøv igjen seinare.',
        },
        showing: 'Viser {} av {}',
        total: 'Totalt: {}',
    },
    savingsAccounts: {
        accountTrackingLabel: 'Gå til sparekonto',
        heading: 'Sparekonto',
        listLabel: 'Sparekontoar',
        loadingLabel: 'Lastar sparekontoar',
        fetchError: 'Kunne ikkje hente sparekontoar. Prøv igjen seinare.',
        emptyStateTitle: 'Sparing på sparekonto',
        emptyStateDescription: 'Spar trygt på konto og ha pengane tilgjengelege når du treng dei. Opprett ein sparekonto på få minutt.',
        emptyStateCreateSavingsAccount: 'Opprett sparekonto',
        interestsLoadingLabel: 'Lastar opptente renter',
        interestsEarnedFirstPart: 'Visste du at du har opptent ',
        interestsEarnedLastPart: ' i renter på kontoar? Rentene blir utbetalte på slutten av året.',
    },
    savingsFunds: {
        fundTrackingLabel: 'Gå til fond: {}',
        heading: 'Fond',
        loadingLabel: 'Lastar fond',
        fetchError: 'Kunne ikkje hente fond. Prøv igjen seinare.',
        seeAllFunds: 'Gå til fondsside',
        hasPendingOrder: 'Ordre på veg',
        noFunds: {
            title: 'Sparing i fond',
            descriptionLineOne: 'Har du eit sparemål som ligg litt fram i tid?',
            descriptionLineTwo: 'Fond kan hjelpe sparepengane dine til å vekse over tid.',
            startFundSaving: 'Lær meir om fondssparing',
            fundGuide: 'Finn fond som passar for deg',
            savingsGrowthCalculator: 'Sjå kva sparinga di kan vekse til',
        },
    },
    authorizedSavingsAccounts: {
        accountTrackingLabel: 'Gå til sparekonto',
        heading: 'Sparekontoar du har tilgang til',
        loadingLabel: 'Lastar delte sparekontoar',
        fetchError: 'Kunne ikkje hente delte sparekontoar. Prøv igjen seinare.',
    },
    authorizedFundAccounts: {
        accountTrackingLabel: 'Gå til fondskonto',
        heading: 'Fondskontoar du har tilgang til',
        loadingLabel: 'Lastar aksjesparekontoar du har tilgang til',
        fetchError: 'Kunne ikkje hente aksjesparekontoar du har tilgang til. Prøv igjen seinare.',
    },
    savingsAgreementsAccounts: {
        seeExistingAgreements: 'Sjå spareavtalar sparekonto',
        startNewAgreement: 'Start spareavtale sparekonto',
        title: 'Fast overføring til konto',
        monthlyAmount: '{} per månad',
        nextPaymentDate: 'Neste trekk den {}',
        startSavingTitle: 'Fast sparing til sparekonto',
        startSavingDescription: 'Set av eit fast beløp kvar månad, så slepp du å hugse det sjølv.',
        loadingLabel: 'Lastar faste overføringar til konto',
        fetchError: 'Kunne ikkje hente faste overføringar til konto. Prøv igjen seinare.',
    },
    savingsAgreementsFunds: {
        seeExistingAgreements: 'Sjå spareavtalar i fond',
        startNewAgreement: 'Start spareavtale i fond',
        title: 'Spareavtale i fond',
        monthlyAmount: '{} per månad',
        nextPaymentDate: 'Neste trekk den {}',
        startSavingTitle: 'Spareavtale i fond',
        startSavingDescription: 'Set av eit fast beløp kvar månad, så slepp du å hugse det sjølv.',
        loadingLabel: 'Lastar spareavtalar i fond',
        fetchError: 'Kunne ikkje hente spareavtalar i fond. Prøv igjen seinare.',
    },
    savingsAgreementsMicrosaving: {
        seeExistingAgreements: 'Sjå mikrosparavtalar',
        startNewAgreement: 'Start mikrosparing',
        title: 'Mikrosparing',
        oneAgreement: 'Du har {} mikrosparavtale',
        multipleAgreements: 'Du har {} mikrosparavtalar',
        description: 'Sjå dine avtalar',
        loadingLabel: 'Lastar mikrosparavtalar',
        fetchError: 'Kunne ikkje hente mikrosparavtalar. Prøv igjen seinare.',
        startTitle: 'Mikrosparing',
        startDescription: 'Spar automatisk kvar gong du bruker kortet. Kom i gang med mikrosparing.',
    },
    savingsEncouragement: {
        loadingLabel: 'Lastar sparetips',
        texts: {
            NO_SAVINGS_PRODUCTS: 'Kom i gang med sparing! Finn ei sparing som passar for deg.',
            ACCOUNT_NO_FUNDS: 'Skal du spare over lengre tid? Sjå om fond kan passe for delar av sparinga di.',
            ACCOUNT_FUNDS_NO_AGREEMENTS: 'Gjer sparinga enklare med ei spareavtale. Vel eit beløp som blir sett av automatisk kvar månad.',
            ACCOUNT_FUNDS_AGREEMENTS: 'Bra jobba - du sparer jamt og trutt! Sjølv eit lite beløp kan vekse seg stort over tid.',
        },
        actions: {
            FIND_SAVINGS_PRODUCT: 'Finn ei sparing',
            VIEW_FUNDS: 'Sjå sparing i fond',
            START_SAVING_AGREEMENT: 'Start fast sparing',
            INCREASE_SAVINGS_AMOUNT: 'Auk sparebeløp',
        },
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm4uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi9zcmMvYXBwcy9zYXZpbmdzLW92ZXJ2aWV3L3RyYW5zbGF0aW9ucy9ubi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxNQUFNLENBQUMsTUFBTSxpQkFBaUIsR0FBb0M7SUFDOUQsZUFBZSxFQUFFO1FBQ2IsMEJBQTBCLEVBQUU7WUFDeEIsU0FBUyxFQUFFLHVCQUF1QjtZQUNsQyxZQUFZLEVBQUUsOEJBQThCO1lBQzVDLFVBQVUsRUFBRSxlQUFlO1lBQzNCLFlBQVksRUFBRSxZQUFZO1lBQzFCLFVBQVUsRUFBRSxNQUFNO1lBQ2xCLFdBQVcsRUFBRSxRQUFRO1lBQ3JCLFlBQVksRUFBRSx5Q0FBeUM7WUFDdkQsU0FBUyxFQUFFLGdFQUFnRTtTQUM5RTtRQUNELE9BQU8sRUFBRSxnQkFBZ0I7UUFDekIsS0FBSyxFQUFFLFlBQVk7S0FDdEI7SUFDRCxlQUFlLEVBQUU7UUFDYixvQkFBb0IsRUFBRSxtQkFBbUI7UUFDekMsT0FBTyxFQUFFLFlBQVk7UUFDckIsU0FBUyxFQUFFLGNBQWM7UUFDekIsWUFBWSxFQUFFLHFCQUFxQjtRQUNuQyxVQUFVLEVBQUUscURBQXFEO1FBQ2pFLGVBQWUsRUFBRSx1QkFBdUI7UUFDeEMscUJBQXFCLEVBQ2pCLHdHQUF3RztRQUM1Ryw4QkFBOEIsRUFBRSxvQkFBb0I7UUFDcEQscUJBQXFCLEVBQUUsd0JBQXdCO1FBQy9DLHdCQUF3QixFQUFFLDhCQUE4QjtRQUN4RCx1QkFBdUIsRUFBRSxrRUFBa0U7S0FDOUY7SUFDRCxZQUFZLEVBQUU7UUFDVixpQkFBaUIsRUFBRSxpQkFBaUI7UUFDcEMsT0FBTyxFQUFFLE1BQU07UUFDZixZQUFZLEVBQUUsYUFBYTtRQUMzQixVQUFVLEVBQUUsNkNBQTZDO1FBQ3pELFdBQVcsRUFBRSxrQkFBa0I7UUFDL0IsZUFBZSxFQUFFLGNBQWM7UUFDL0IsT0FBTyxFQUFFO1lBQ0wsS0FBSyxFQUFFLGdCQUFnQjtZQUN2QixrQkFBa0IsRUFBRSwrQ0FBK0M7WUFDbkUsa0JBQWtCLEVBQUUseURBQXlEO1lBQzdFLGVBQWUsRUFBRSwwQkFBMEI7WUFDM0MsU0FBUyxFQUFFLDhCQUE4QjtZQUN6Qyx1QkFBdUIsRUFBRSxtQ0FBbUM7U0FDL0Q7S0FDSjtJQUNELHlCQUF5QixFQUFFO1FBQ3ZCLG9CQUFvQixFQUFFLG1CQUFtQjtRQUN6QyxPQUFPLEVBQUUsaUNBQWlDO1FBQzFDLFlBQVksRUFBRSwyQkFBMkI7UUFDekMsVUFBVSxFQUFFLDJEQUEyRDtLQUMxRTtJQUNELHNCQUFzQixFQUFFO1FBQ3BCLG9CQUFvQixFQUFFLG1CQUFtQjtRQUN6QyxPQUFPLEVBQUUsaUNBQWlDO1FBQzFDLFlBQVksRUFBRSw2Q0FBNkM7UUFDM0QsVUFBVSxFQUFFLDZFQUE2RTtLQUM1RjtJQUNELHlCQUF5QixFQUFFO1FBQ3ZCLHFCQUFxQixFQUFFLDZCQUE2QjtRQUNwRCxpQkFBaUIsRUFBRSw4QkFBOEI7UUFDakQsS0FBSyxFQUFFLDJCQUEyQjtRQUNsQyxhQUFhLEVBQUUsY0FBYztRQUM3QixlQUFlLEVBQUUsb0JBQW9CO1FBQ3JDLGdCQUFnQixFQUFFLDZCQUE2QjtRQUMvQyxzQkFBc0IsRUFBRSxrRUFBa0U7UUFDMUYsWUFBWSxFQUFFLHFDQUFxQztRQUNuRCxVQUFVLEVBQUUscUVBQXFFO0tBQ3BGO0lBQ0Qsc0JBQXNCLEVBQUU7UUFDcEIscUJBQXFCLEVBQUUseUJBQXlCO1FBQ2hELGlCQUFpQixFQUFFLDBCQUEwQjtRQUM3QyxLQUFLLEVBQUUsb0JBQW9CO1FBQzNCLGFBQWEsRUFBRSxjQUFjO1FBQzdCLGVBQWUsRUFBRSxvQkFBb0I7UUFDckMsZ0JBQWdCLEVBQUUsb0JBQW9CO1FBQ3RDLHNCQUFzQixFQUFFLGtFQUFrRTtRQUMxRixZQUFZLEVBQUUsNEJBQTRCO1FBQzFDLFVBQVUsRUFBRSw0REFBNEQ7S0FDM0U7SUFDRCw0QkFBNEIsRUFBRTtRQUMxQixxQkFBcUIsRUFBRSxzQkFBc0I7UUFDN0MsaUJBQWlCLEVBQUUsb0JBQW9CO1FBQ3ZDLEtBQUssRUFBRSxjQUFjO1FBQ3JCLFlBQVksRUFBRSwyQkFBMkI7UUFDekMsa0JBQWtCLEVBQUUsNEJBQTRCO1FBQ2hELFdBQVcsRUFBRSxrQkFBa0I7UUFDL0IsWUFBWSxFQUFFLHlCQUF5QjtRQUN2QyxVQUFVLEVBQUUseURBQXlEO1FBQ3JFLFVBQVUsRUFBRSxjQUFjO1FBQzFCLGdCQUFnQixFQUFFLDBFQUEwRTtLQUMvRjtJQUNELG9CQUFvQixFQUFFO1FBQ2xCLFlBQVksRUFBRSxrQkFBa0I7UUFDaEMsS0FBSyxFQUFFO1lBQ0gsbUJBQW1CLEVBQUUsNkRBQTZEO1lBQ2xGLGdCQUFnQixFQUFFLGdGQUFnRjtZQUNsRywyQkFBMkIsRUFDdkIsaUdBQWlHO1lBQ3JHLHdCQUF3QixFQUNwQix5RkFBeUY7U0FDaEc7UUFDRCxPQUFPLEVBQUU7WUFDTCxvQkFBb0IsRUFBRSxpQkFBaUI7WUFDdkMsVUFBVSxFQUFFLG9CQUFvQjtZQUNoQyxzQkFBc0IsRUFBRSxvQkFBb0I7WUFDNUMsdUJBQXVCLEVBQUUsZ0JBQWdCO1NBQzVDO0tBQ0o7Q0FDSixDQUFDIn0=